import { createContext, useContext } from 'react';

export interface WebformContextProps {
  id: string;
  pages: string[];
  currentPage: string;
  currentElement: string;
  updateCurrentPage: (currentPage: string) => void;
  updateCurrentElement: (currentElement: string) => void;
}

export const WebformContext = createContext<WebformContextProps>({
  id: '',
  pages: [],
  currentPage: '',
  currentElement: '',
  updateCurrentPage: () => {},
  updateCurrentElement: () => {},
});

export function useWebformContext() {
  return useContext(WebformContext);
}
